import moment from "moment";

export const convertNumbertoDate = (number: any) => {
  let utcSeconds = number;
  let date: any = new Date(0);
  date.setUTCSeconds(utcSeconds);
  date = moment(date).format("MMM DD yyyy");
  return date.toString();
};
